const loaderTrackingForm = () => {
  const buttons = document.querySelectorAll(".tracking-submit");

  buttons.forEach(button => {
    button.addEventListener("click", ()=> {
      const loading = button.querySelector(".traking-form-loader");
      loading.classList.remove("d-none");
      button.querySelector(".normaltext-button").classList.add("d-none");

      setTimeout(() => {
        loading.classList.add("d-none");
        button.querySelector(".normaltext-button").classList.remove("d-none");
      }, 2500);
    })
  });
}

loaderTrackingForm();